import React from 'react';

import {
  authUtil,
  routeDirectory
} from 'modules';

import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';



export const NoStoresActivity: React.FC = () => {
  const navigate = useNavigate();


  const handleClickLogOut = React.useCallback(
    async () => {
      await authUtil.logOut();
      navigate(routeDirectory.auth.logIn.path());
    },
    [navigate]
  );

  return (
    <div>
      No stores found

      <Button onClick={handleClickLogOut}>
        Log Out
      </Button>
    </div>
  );
};
